import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowheadDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 6,
	viewBox: "0 0 10 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.999806 0.999903L5.10147 5.10156L9.20313 0.999903",
		stroke: "black",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowheadDown;
